import { getAxios } from '~/plugins/nikan-api'
import Endpoints from '@nikan/endpoints'
import qs from 'querystring'

export const KEYS = {
  CLEAR: 'CLEAR_USER_AUTH',
  CLEARALL: 'CLEAR_ALL',
  CLEARCUSTOMER: 'CLEAR_CUSTOMER',
  SET: 'SET_USER_AUTH',
  ADD_FISCAL: 'setUserCurrentFiscal',
  ADD_COMPANY: 'setUserCurrentCompany',
  ADD_CUSTOMER: 'setUserCurrentCustomer',
  ADD_CUSTOMERCODE: 'setUserCurrentCustomerCode',
  ADD_REVIEWMODEDATA: 'setReviewModeData',
  ADD_WORKSHOP: 'setUserCurrentWorkshop',
  ADD_SALARYPERIOD: 'setUserCurrentSalaryPeriod',
}

export const state = {
  user: null,
  fiscalId: null,
  companyId: null,
  customerId: null,
  customerCode: null,
  reviewModeData: null,
  workshopId: null,
  salaryPeriodId: null,
}

export const mutations = {
  [KEYS.CLEAR](state) {
    state.user = null
  },

  [KEYS.CLEARALL](state) {
    state.user = null
    state.fiscalId = null
    state.companyId = null
    state.customerId = null
    state.workshopId = null
    state.salaryPeriodId = null
  },

  [KEYS.CLEARCUSTOMER](state) {
    state.customerCode = null
  },

  [KEYS.SET](state, user) {
    state.user = user
  },

  [KEYS.ADD_FISCAL](state, id) {
    state.fiscalId = id
  },
  [KEYS.ADD_COMPANY](state, id) {
    state.companyId = id
  },
  [KEYS.ADD_CUSTOMER](state, id) {
    state.customerId = id
  },
  [KEYS.ADD_CUSTOMERCODE](state, code) {
    state.customerCode = code
  },
  [KEYS.ADD_REVIEWMODEDATA](state, mode) {
    state.reviewModeData = mode
  },
  [KEYS.ADD_WORKSHOP](state, id) {
    state.workshopId = id
  },
  [KEYS.ADD_SALARYPERIOD](state, id) {
    state.salaryPeriodId = id
  },
}

export const remote = {
  login(payload, state) {
    let url = Endpoints.getUrl('token').address

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }

    if (payload.fiscalId != null) config.headers['NIKAN_APP_FISCAL'] = payload.fiscalId
    if (payload.companyId != null) config.headers['NIKAN_APP_COMPANY'] = payload.companyId
    if (payload.customerId != null) config.headers['NIKAN_APP_CUSTOMER'] = payload.customerId
    if (payload.workshopId != null) config.headers['NIKAN_APP_WORKSHOP'] = payload.workshopId
    if (payload.salaryPeriodId != null) config.headers['NIKAN_APP_SALARYPERIOD'] = payload.salaryPeriodId
    config.headers['CCODE'] = state.customerCode

    return getAxios()
      .post(url, qs.stringify(payload), config)
      .then(result => {
        return result.data
      })
  }
}

export const actions = {
  authenticateUser({ state, commit }, payload) {
    if (payload.username && payload.password || (payload.username && payload.username.startsWith('googletoken='))) {
      return remote.login(payload, state)
        .then(result => {
          commit(KEYS.SET, result)
          let adds = result.additional_data || {}

          commit(KEYS.ADD_FISCAL, adds['NIKAN_APP_FISCAL'])
          commit(KEYS.ADD_COMPANY, adds['NIKAN_APP_COMPANY'])
          commit(KEYS.ADD_CUSTOMER, adds['NIKAN_APP_CUSTOMER'])
          commit(KEYS.ADD_WORKSHOP, adds['NIKAN_APP_WORKSHOP'])
          commit(KEYS.ADD_SALARYPERIOD, adds['NIKAN_APP_SALARYPERIOD'])
          return result
        })
    } else {
      return Promise.reject(new Error('IncompleteFields'))
    }
  },
  clearUser({ commit }) {
    commit(KEYS.CLEAR)
  },
  clearAll({ commit }) {
    commit(KEYS.CLEARALL)
  },
  clearCustomer({ commit }) {
    commit(KEYS.CLEARCUSTOMER)
  },
  applyDetails({ commit }, payload) {
    let { user, fiscalId, companyId, customerId, customerCode, reviewModeData, workshopId, salaryPeriodId } = payload

    if (user)
      commit(KEYS.SET, user)
    if (fiscalId)
      commit(KEYS.ADD_FISCAL, fiscalId)
    if (companyId)
      commit(KEYS.ADD_COMPANY, companyId)
    if (customerId)
      commit(KEYS.ADD_CUSTOMER, customerId)
    if (customerCode)
      commit(KEYS.ADD_CUSTOMERCODE, customerCode)
    if (reviewModeData)
      commit(KEYS.ADD_REVIEWMODEDATA, reviewModeData)
    if (workshopId)
      commit(KEYS.ADD_WORKSHOP, workshopId)
    if (salaryPeriodId)
      commit(KEYS.ADD_SALARYPERIOD, salaryPeriodId)
  },
  makeReviewModeDataEmpty({ commit }) {
    commit(KEYS.ADD_REVIEWMODEDATA, null)
  },
  refresh({ commit }, payload) {
    commit(KEYS.SET, payload.user)
    commit(KEYS.ADD_FISCAL, payload.fiscalId)
  }
}

export const getters = {
  currentUser: state => state.user,
  currentUserDetails: state => {
    return {
      user: state.user,
      fiscalId: state.fiscalId,
      fiscalPeriodId: state.fiscalId,
      companyId: state.companyId,
      customerId: state.customerId,
      customerCode: state.customerCode,
      reviewModeData: state.reviewModeData,
      workshopId: state.workshopId,
      salaryPeriodId: state.salaryPeriodId,
    }
  },
  reviewModeData: state => state.reviewModeData,
  hasFiscal: state => state.user != null && state.fiscalId != null,
  hasCompany: state => state.user != null && state.companyId != null,
  hasCustomer: state => state.user != null && state.customerId != null,
  hasWorkshop: state => state.user != null && state.workshopId != null,
  hasSalaryPeriod: state => state.user != null && state.salaryPeriodId != null
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
